import _ from "lodash"

import { isCpfOrCnpj, isName } from "services/utils/regexForValidations"
import { EXPORT_DATA } from "./constants"

export const checkCustomer = (customerSelected, isAsset, action) => {
  if (_.isNil(customerSelected) || _.isNil(isAsset)) {
    return
  }

  const isCancel = action === "Cancelar portabilidade"
  const records = _.get(customerSelected, "records", [])
  let portabilityType, portabilityStatus, isInterrupted

  if (!isAsset) {
    const recordsPortability = _.filter(records, (record) => {
      portabilityType = _.get(record, "PROTOCOLO TYPE", "")
      portabilityStatus = _.get(record, "SUB STATUS PROTOCOLO", "")

      const isPortable = portabilityType === "PORTABILIDADE"
      isInterrupted = portabilityStatus === "INTERROMPIDO"

      return (isPortable && isCancel) || (isPortable && !isInterrupted)
    })

    return {
      hasResult: recordsPortability && recordsPortability.length > 0,
      status: isInterrupted ? portabilityStatus : portabilityType
    }
  }

  return { hasResult: records && records.length > 0, status: "NOT_FOUND" }
}

export const validate = (values, action) => {
  const isEdition = action === "Editar cliente"
  const isReschedule = action === "Reagendar portabilidade"

  const errors = {}

  if (isEdition) {
    if (!isCpfOrCnpj(values.document)) {
      errors.document = "*CPF ou CNPJ inválido"
    }

    if (!values.customerNewName) {
      errors.customerNewName = "*Nome completo precisa ser preenchido"
    } else if (!isName(values.customerNewName)) {
      errors.customerNewName = "*Nome completo incorreto"
    } else if (values.customerNewName.trim().length < 3) {
      errors.customerNewName =
        "*Nome completo precisa de no mínimo 3 caracteres"
    }
  } else {
    if (values.protocol === 0) {
      errors.protocol = "*Selecionar pelo menos um protocolo"
    }

    if (isReschedule) {
      if (!values.date) {
        errors.date = "*Escolha uma data"
      }

      if (!values.time) {
        errors.time = "*Escolha o horário"
      }
    }
  }

  return errors
}

export const getMappedData = (dateArray) => {
  return dateArray.reduce((acc, curr) => {
    const date = new Date(curr.date + " GMT-0300")
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const year = date.getFullYear()

    const brazilianDateKey = `${day}/${month}/${year}`

    const hours = String(date.getHours()).padStart(2, "0")
    const minutes = String(date.getMinutes()).padStart(2, "0")
    const timeFormatted = `${hours}:${minutes}`

    const valueObject = {
      hour: timeFormatted,
      originalDate: curr.date
    }

    if (!acc[brazilianDateKey]) {
      acc[brazilianDateKey] = []
    }

    acc[brazilianDateKey].push(valueObject)

    return acc
  }, {})
}

export const validateExportType = (action) => {
  return _.includes(EXPORT_DATA, action)
}



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/ActionForm/helpers.js